<template>
  <div>
    <flickity v-if="users" ref="slider" :options="slider.options">
      <div v-for="_user in users" :key="_user.id" class="carousel-cell max">
        <div class="user-details">
          <h1>{{ _user.firstName }} {{ _user.lastName }}</h1>
          <TimeRow :user="_user" />
          <avatar :user="_user" :hide-nick-name="true" :width="100" />
          <OverdueRow :user="user" class="overdue-row" />
          <LeaveRow :user="user" />
        </div>
      </div>
    </flickity>
    <LoadingSkeleton v-if="$apollo.queries.user.loading" />
    <div v-else>
      <UserDashboard :key="userId" :user="user" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import UserDashboard from "@/components/userdashboard"
import flickity from "vue-flickity"
import avatar from "@/components/projectAvatar"
import LoadingSkeleton from "@/components/userdashboard/loadSkeleton"
import TimeRow from "@/components/teammember/userBlock/timeRow"
import OverdueRow from "@/components/teammember/userBlock/overdueRow"
import LeaveRow from "@/components/teammember/userBlock/leaveRow"

export default {
  name: "User",
  components: {
    UserDashboard,
    flickity,
    avatar,
    LoadingSkeleton,
    TimeRow,
    OverdueRow,
    LeaveRow
  },
  data() {
    return {
      slider: {
        options: {
          pageDots: false,
          wrapAround: true
        }
      }
    }
  },
  watch: {
    $route() {
      this.$router.go()
    }
  },
  apollo: {
    user: {
      query: require("@/graphql/Account/GetUserLW.gql"),
      variables() {
        return {
          fullName: `${this.$route.params.user}`
        }
      },
      update(data) {
        if (!data.user) {
          this.$toasted.error("User not found")
          this.$router.back()
        }
        return data.user
      }
    },
    users: {
      query: require("@/graphql/Account/GetUsersWithTimeLogs.gql"),
      //This subscriptions allows timelogs to update without refreshing the page
      subscribeToMore: {
        document: require("@/graphql/TimeLog/TimeLogAdded.gql"),
        updateQuery(previousResult, { subscriptionData }) {
          if (!this.users) return //users aren't set - don't need subscription
          let timeLog = subscriptionData.data.timeLogAdded
          this.users
            .find(x => x.id == timeLog.user.id)
            .recentTimeLogs.push(timeLog)
        }
      },
      update(data) {
        data.users = data.users.filter(x => x).sortBy(x => x.firstName)
        setTimeout(() => {
          this.$refs.slider.select(
            data.users.indexOf(data.users.find(x => x.id === this.user.id))
          )
          this.$refs.slider.on("change", index => {
            this.user = data.users[index]
          })
        }, 48)

        return data.users
      },
      fetchPolicy: "no-cache"
    }
  },
  computed: {
    ...mapGetters({
      getUserByFullName: "getUserByFullName"
    }),
    userId() {
      return this.user?.id
    }
  }
}
</script>
<style scoped>
.user-details {
  text-align: center;
}
.user-details img {
  width: 100px;
}
.user-details h1 {
  margin-top: 10px;
}
.carousel-cell {
  width: 50%;
  height: 165px;
  margin-right: 10px;
  opacity: 0.3;
}

.overdue-row {
  margin: 1rem 0;
}
</style>
<style>
.flickity-viewport {
  height: 25rem !important;
}

.carousel-cell {
  transition: 0.75s ease-in-out;
}

.carousel-cell:not(.is-selected) > div > .overdue-row,
.carousel-cell:not(.is-selected) > div > .leave-row,
.carousel-cell:not(.is-selected) > div > .time-row {
  opacity: 0;
}
</style>
